// Keep in sync with _app.tsx
export enum FontVariableName {
  RobotoMono = "--roboto-mono",
}
